import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../shared/authentication.service';
import { Subscription } from 'rxjs';
import { AngularFireAuth } from '@angular/fire/auth';
import { ApiService } from '../../shared/api.service';

@Component({
  selector: 'app-user-register',
  templateUrl: './user-register.component.html',
  styleUrls: ['./user-register.component.css']
})
export class UserRegisterComponent implements OnInit, OnDestroy {

  registerForm: FormGroup;
  loading = false;
  submitted = false;
  authSubscription: Subscription;


  constructor(
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private angularFireAuth: AngularFireAuth,
    private router: Router,
    private apiService: ApiService
  ) {
  }

  ngOnInit() {
    this.authSubscription = this.angularFireAuth.authState.subscribe(async user => {
      if (user && user.uid) {
        await this.router.navigate(['/tests']);
      }
    });
    this.registerForm = this.formBuilder.group({
      displayName: ['', Validators.required],
      email: ['', [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]], // email pattern
      password: ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  ngOnDestroy() {
    this.authSubscription.unsubscribe();
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.registerForm.controls;
  }

  async onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.registerForm.invalid) {
      return;
    }
    const data = {
      displayName: this.f.displayName.value,
      password: this.f.password.value,
      email: this.f.email.value,
      activated: true
    };

    this.loading = true;
    try {
      const response = await this.apiService.createUser(data);
      if (response) {
        await this.angularFireAuth.signInWithEmailAndPassword(data.email, data.password);
        await this.router.navigate(['/tests']);
      }
    } catch (e) {
      console.log(e);
      await this.router.navigate(['/']);

    }
  }

}
